import {
    STREAMING_GET_MY_ACTIVE_STREAM,
    STREAMING_ADD_MY_STREAM,
    STREAMING_UPDATE_MY_STREAM,
    STREAMING_UPDATE_MY_STREAM_DETAILS,
    STREAMING_ADDNEW_TV,
    STREAMING_UPDATE_TV,
    STREAMING_ALL_TVs,
    STREAMING_DELETE_TV,
    STREAMING_GET_MY_EVENT_EARNINGS,
    STREAMING_GET_MY_EVENT_CHATS,
    STREAMING_ADD_STREAM_LOCATION,
    STREAMING_UPDATE_STREAM_LOCATION,
    STREAMING_DELETE_STREAM_LOCATION,
    STREAMING_GET_ALL_STREAM_LOCATION,
    STREAMING_CHECK_STREAM_STATUS,
    STREAMING_GET_STREAM_SESSIONS,
    STREAMING_SET_DEFAULT_DEMPED_HLS,
    STREAMING_GET_EVENT_VIEWS,
    STREAMING_GET_PAST_STREAMS,
    STREAMING_UPDATE_STREAM,
    STREAMING_SET_STREAM_ACTIVE,
    STREAMING_DELETE_STREAM,
    STREAMING_DELETE_STREAM_SESSION,
    STREAMING_MERGE_STREAM,
    STREAMING_DOWNLOAD_STREAM,
    STREAMING_GET_STREAM_DOWNLOADS,
    STREAMING_GET_STREAM_ANALYTICS,
    STREAMING_GET_STREAM_LOGS,
    STREAMING_GET_STREAM_HEALTH,
    STREAMING_CLOSE_MY_STREAM,
    STREAMING_END_MY_STREAM,
    STREAMING_SEND_MY_EVENT_CHAT
} from "../actions/streaming";

import {
    API_BASE_URL,
    MEDIA_SERVER_API_BASE_URL,
    STREAMING_GET_MY_ACTIVE_STREAM_URL,
    STREAMING_ADD_MY_STREAM_URL,
    STREAMING_UPDATE_MY_STREAM_URL,
    STREAMING_UPDATE_MY_STREAM_DETAILS_URL,
    STREAMING_ADDNEW_TV_URL,
    STREAMING_UPDATE_TV_URL,
    STREAMING_ALL_TVs_URL,
    STREAMING_DELETE_TV_URL,
    STREAMING_GET_MY_EVENT_EARNINGS_URL,
    STREAMING_GET_MY_EVENT_CHATS_URL,
    STREAMING_ADD_STREAM_LOCATION_URL,
    STREAMING_UPDATE_STREAM_LOCATION_URL,
    STREAMING_DELETE_STREAM_LOCATION_URL,
    STREAMING_GET_ALL_STREAM_LOCATION_URL,
    STREAMING_CHECK_STREAM_STATUS_URL,
    STREAMING_GET_STREAM_SESSIONS_URL,
    STREAMING_SET_DEFAULT_DEMPED_HLS_URL,
    STREAMING_GET_EVENT_VIEWS_URL,
    STREAMING_GET_PAST_STREAMS_URL,
    STREAMING_UPDATE_STREAM_URL,
    STREAMING_SET_STREAM_ACTIVE_URL,
    STREAMING_DELETE_STREAM_URL,
    STREAMING_DELETE_STREAM_SESSION_URL,
    STREAMING_MERGE_STREAM_URL,
    STREAMING_DOWNLOAD_STREAM_URL,
    STREAMING_GET_STREAM_DOWNLOADS_URL,
    STREAMING_GET_STREAM_ANALYTICS_URL,
    STREAMING_GET_STREAM_LOGS_URL,
    STREAMING_GET_STREAM_HEALTH_URL,
    STREAMING_CLOSE_MY_STREAM_URL,
    STREAMING_END_MY_STREAM_URL,
    STREAMING_SEND_MY_EVENT_CHAT_URL
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [STREAMING_SEND_MY_EVENT_CHAT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_SEND_MY_EVENT_CHAT_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_END_MY_STREAM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: MEDIA_SERVER_API_BASE_URL + STREAMING_END_MY_STREAM_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_CLOSE_MY_STREAM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_CLOSE_MY_STREAM_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_STREAM_HEALTH]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: MEDIA_SERVER_API_BASE_URL + STREAMING_GET_STREAM_HEALTH_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_STREAM_LOGS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: MEDIA_SERVER_API_BASE_URL + STREAMING_GET_STREAM_LOGS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_STREAM_ANALYTICS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_GET_STREAM_ANALYTICS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_STREAM_DOWNLOADS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: MEDIA_SERVER_API_BASE_URL + STREAMING_GET_STREAM_DOWNLOADS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_DOWNLOAD_STREAM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: MEDIA_SERVER_API_BASE_URL + STREAMING_DOWNLOAD_STREAM_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_MERGE_STREAM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: MEDIA_SERVER_API_BASE_URL + STREAMING_MERGE_STREAM_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_DELETE_STREAM_SESSION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: MEDIA_SERVER_API_BASE_URL + STREAMING_DELETE_STREAM_SESSION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_UPDATE_STREAM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_UPDATE_STREAM_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_SET_STREAM_ACTIVE]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_SET_STREAM_ACTIVE_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_DELETE_STREAM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_DELETE_STREAM_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_PAST_STREAMS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_GET_PAST_STREAMS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_EVENT_VIEWS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_GET_EVENT_VIEWS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_SET_DEFAULT_DEMPED_HLS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_SET_DEFAULT_DEMPED_HLS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_STREAM_SESSIONS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: MEDIA_SERVER_API_BASE_URL + STREAMING_GET_STREAM_SESSIONS_URL + `/${payload.event_id}`,
            method: "GET",
            data: payload,
        });
    },
    [STREAMING_CHECK_STREAM_STATUS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_CHECK_STREAM_STATUS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_ADD_STREAM_LOCATION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_ADD_STREAM_LOCATION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_UPDATE_STREAM_LOCATION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_UPDATE_STREAM_LOCATION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_DELETE_STREAM_LOCATION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_DELETE_STREAM_LOCATION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_ALL_STREAM_LOCATION]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_GET_ALL_STREAM_LOCATION_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_MY_EVENT_CHATS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_GET_MY_EVENT_CHATS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_DELETE_TV]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_DELETE_TV_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_ALL_TVs]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_ALL_TVs_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_ADDNEW_TV]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_ADDNEW_TV_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_UPDATE_TV]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_UPDATE_TV_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_UPDATE_MY_STREAM_DETAILS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_UPDATE_MY_STREAM_DETAILS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_UPDATE_MY_STREAM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_UPDATE_MY_STREAM_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_ADD_MY_STREAM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_ADD_MY_STREAM_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_MY_ACTIVE_STREAM]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_GET_MY_ACTIVE_STREAM_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
    [STREAMING_GET_MY_EVENT_EARNINGS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + STREAMING_GET_MY_EVENT_EARNINGS_URL,
            method: "POST",
            data: payload,
            headers: {
                'Authorization': 'Bearer ' + getters.getUserAccessToken,
            }
        });
    },
};


export default {
    mutations,
    actions,
    getters,
    state
};